<template>
    <div>
        <div class="upload-header py-1" id="visit-attachments-hc">
            <h6 class="d-inline mr-auto">Attachments</h6>

            <div
                class="d-flex align-items-center justify-content-between"
                v-if="addPatientDocumentsPermission && !loadingAttachments"
            >
                <span>
                    Click Add Attachment to upload files associated with this task. Once uploaded, files will appear
                    below
                </span>
                <div class="">
                    <button
                        type="button"
                        @click="toggleAddAttachment"
                        class="btn btn-primary border border-primary"
                        :disabled="isPlanner"
                    >
                        Add Attachment
                    </button>
                </div>
            </div>
        </div>
        <div class="upload-filters">
            <slot name="document-filters"></slot>
        </div>
        <div class="doc-body">
            <table class="table table-responsive-md borderless">
                <thead>
                    <tr class="bg-table-header">
                        <th>File</th>
                        <th></th>
                        <th class="text-end">Actions</th>
                    </tr>
                </thead>
                <tbody v-if="taskAttchments?.length == 0 && !loadingAttachments">
                    <TableEmpty :col-span="5" component="attachments" secondary-message="No Attachments to Display" />
                </tbody>
                <tbody v-else>
                    <template v-if="loadingAttachments">
                        <tr v-for="i in loadingCount" :key="i">
                            <td><span class="shimmer-loading block-size-8"></span></td>
                            <td><span class="shimmer-loading block-size-6"></span></td>
                            <td><span class="shimmer-loading block-size-4"></span></td>
                        </tr>
                    </template>

                    <template v-if="!loadingAttachments">
                        <tr v-for="document in taskAttchments" :key="document.AssetId">
                            <td>
                                <i class="far fa-file me-1 fa-lg"></i>
                                <a href="javascript:void(0);" @click="downloadDocuments(document)">{{
                                    document.FileName
                                }}</a>
                            </td>
                            <td>
                                <div
                                    class="d-flex gap-2 justify-content-center align-items-center"
                                    v-if="document.UploadedDocumentationType !== uploadedDocumentationTypeEnum.None"
                                >
                                    <template
                                        v-for="[, information] in uploadedDocumentationType"
                                        :key="information.name"
                                    >
                                        <div
                                            class="d-none"
                                            v-if="information.value === uploadedDocumentationTypeEnum.None"
                                        ></div>
                                        <div class="form-check align-items-center" v-else>
                                            <input
                                                type="radio"
                                                :name="`uploadedDocumentationType_${document.AssetId}`"
                                                :id="`uploadedDocumentationType_${document.AssetId}_${information.name}`"
                                                disabled
                                                :value="information.value"
                                                :checked="document.UploadedDocumentationType === information.value"
                                            />
                                            <label
                                                class="m-0 ms-1"
                                                for="file_single_0716f4a9-0c20-40a6-8956-83e50d91ee3c"
                                                >{{ information.longDescription }}</label
                                            >
                                        </div>
                                    </template>
                                </div>
                            </td>
                            <!-- DELETE -->
                            <td colspan="4" v-if="attachmentToDelete === document?.AssetId">
                                <TablePrompt
                                    ok-text="Delete"
                                    cancelText="Cancel"
                                    operation=" "
                                    name="Delete"
                                    :includeYes="true"
                                    :isInProgress="isDeleteInProgress"
                                    :ok="deleteSelectedDocument"
                                    :cancel="cancelDeleteAttachment"
                                />
                            </td>
                            <!-- ACTIONS  -->
                            <td class="text-end" v-else>
                                <template v-if="editPatientDocumentsPermission || deletePatientDocumentsPermission">
                                    <button
                                        type="button"
                                        class="btn table-btn btn-outline-danger"
                                        @click="requestDelete(document?.AssetId)"
                                        v-tooltip="{ title: 'Delete' }"
                                        v-if="deletePatientDocumentsPermission"
                                        :disabled="isPlanner"
                                    >
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                    <button
                                        type="button"
                                        class="btn table-btn btn-outline-info au-target"
                                        @click="openSelectedDocument(document)"
                                        v-tooltip="{ title: 'View' }"
                                    >
                                        <i class="fa fa-eye"></i>
                                    </button>
                                </template>
                                <i class="text-default" v-else>No Actions</i>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts" src="./VisitAttachmentsHC.ts" />
<style lang="scss" src="./VisitAttachmentsHC.scss" />
